import {Directive, Input, OnChanges, OnInit, SimpleChanges, Type, ViewContainerRef} from "@angular/core";
import {ComponentType} from '@angular/cdk/overlay';

@Directive({
    selector: '[mydocmaCustomButtonContent]'
})

export class ButtonDirective implements OnChanges, OnInit {
    @Input() customComponent: ComponentType<any>;

    constructor(public viewContainerRef: ViewContainerRef) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.customComponent.currentValue) {
            this.loadComponent(this.viewContainerRef, this.customComponent);
        }

    }

    ngOnInit(): void {

    }

    private loadComponent(containerRef, component: Type<any>) {
        const viewContainerRef = containerRef;
        viewContainerRef?.clear();
        viewContainerRef.createComponent(component);
    }

}
